export class AjaxClick {
    constructor() {
        e5.on({
            type: "click",
            selector: "[data-e5buildcall]",
            listener: (e) => {
                const url = e.target.getAttribute("data-e5buildcall");
                const r = new XMLHttpRequest();
                r.open('GET', url);
                r.send();
            }
        });
    }
}